/**
 * @file tuple Create the corresponding tuple type by string constants.
 * @author yuzong(yuzong@tencent.com)
 */

/**
 * Create the corresponding tuple type by string constants.
 *
 * @param args string constants
 * @return string constants
 */
export function tuple() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return args;
}